import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from "@angular/common";
import { ObjectLiteral } from 'src/app/_models/user';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subject, catchError, filter, map, of, repeat, retry, take, throwError, timeout } from 'rxjs';
import { API, ENVIRONMENT } from 'src/app/_constants/app.constants';
import { LANGUAGE, LANGUAGES_SUPPORTED } from 'src/app/_constants/app.constants';
import { LoggerService } from '../../ui/logger/logger.service';
import { SharedModule } from 'src/app/_components/shared.module';
import { AppModule } from 'src/app/app.module';
import { ServiceModule } from 'src/app/_services/service.module';
import { Router } from '@angular/router';

@Injectable({
  providedIn: ServiceModule,
})
export class LanguageService {

  //variables
  private window: Window;

  private _currentLanguage: string = '';

  private _browserLanguage: string = '';

  private readonly _defaultLanguage: string = LANGUAGE.ENGLISH; //constant

  public _constants: ObjectLiteral;

  public languageChanges = new BehaviorSubject<string>(this._currentLanguage);

  languageServiceStreamer = new Subject();

  get currentLanguage(): string {
    return this._currentLanguage;
  }

  set currentLanguage(value: string) {
    this._currentLanguage = value;
  }
  get constants(): ObjectLiteral {
    return this._constants;

  }
  get defaultLanguage(): string {
    return this._defaultLanguage;
  }

  get browserLanguage(): string {
    return this._browserLanguage;
  }

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private http: HttpClient,
    private logger: LoggerService,
    private router: Router,
    // private sessionService: SessionService
  ) {
    this.window = this.document.defaultView;
    this._browserLanguage = this.getDefaultSupportedLang();
    // this.currentLangConfig();
  }

  currentLangConfig(loadLanguagePreferredFromStorage: any) {
    let userPreferredLang = loadLanguagePreferredFromStorage //this.sessionService.loadLanguagePreferredFromStorage();

    if (userPreferredLang != this.browserLanguage && userPreferredLang != this.defaultLanguage) {
      // this.sessionService.removeLanguagePreferred();
      this.currentLanguage = this.browserLanguage;
      return true;
    }

    this.currentLanguage = userPreferredLang;
    return false
  }
  /*
   * @name : getDefaultSupportedLang()
   * checks for the default language and returns it if it is supported or defaults to English
   */
  getDefaultSupportedLang() {
    let lang = this.window.navigator.language;
    let supportedLang = this.getSupportedLang(lang);
    return supportedLang || LANGUAGE.ENGLISH;
  }

  getConstants = async (language = this._currentLanguage): Promise<void> => {
    this.logger.debug('LanguageService.getConstants()', language);
    let url = `${ENVIRONMENT.PROPERTIES.apiUrl}${API.LANGUAGE}/`;
    let body = {
      action: 'GET_LANGUAGE_CONSTANTS',
      lang: language
    }

    let response: any = await new Promise((res: any, rej: any) => {
      this.http.post(encodeURI(url), body).pipe(
        catchError(err => {
          return of({ success: false })
        })
      ).subscribe((data: any) => {
        res(data)
      })
    })

    // await this.http.post(encodeURI(url), body).toPromise().catch(e => e)

    if (response["success"]) {
      this.setConstants(response.data, language)
        if(response.data.unavailable.commonErr =="unavailable-page" ){
          this.router.navigate(['/unavailable'], {
            replaceUrl: true
          });        
      }
    }
  }

  /**
   * @param constants 
   * @param currentLanguage 
   * to set Constants 
   */
  setConstants = (constants: ObjectLiteral, currentLanguage: string) => {
    this._constants = constants;
    this._currentLanguage = currentLanguage;
    // this.sessionService.setLanguage(this._currentLanguage);
    this.languageServiceStreamer.next({ action: 'sessionService.setLangueage', data: this._currentLanguage })
    this.languageChanges.next(currentLanguage);
  }

  /**
   * @returns English variant of the isoCode for sending backend
   * As a fallback will default to English and return.
   */
  convertIsoCode(isoCode: string = this._currentLanguage) {
    let lang = isoCode.split('-')[0];
    return LANGUAGES_SUPPORTED[lang].key || LANGUAGES_SUPPORTED[LANGUAGE.ENGLISH].key;
  }

  /**
   * 
   * @param language 
   * @returns the supported iso-code of the language including location specific and returns false if it is not supported.
   */
  getSupportedLang(language = this._currentLanguage) {
    let lang = language.split('-')[0];
    return LANGUAGES_SUPPORTED[language]?.locale || LANGUAGES_SUPPORTED[lang]?.locale || false;
  }

  /**
   * to compare browser and app default language.
   * can help hide icon
   * @returns boolean
   */
  isBrowserDefaultLanguage(): boolean {
    return this.browserLanguage == this.defaultLanguage || false;
  }
}

